import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=5752998e&scoped=true"
import script from "./QuoteDetail.vue?vue&type=script&lang=js"
export * from "./QuoteDetail.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetail.vue?vue&type=style&index=0&id=5752998e&prod&lang=scss&scoped=true"
import style1 from "./QuoteDetail.vue?vue&type=style&index=1&id=5752998e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752998e",
  null
  
)

export default component.exports